<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div class="条件区">
      <app-wmsm-conditions [show]="true" [ShowSecondDownloadExcel]="false" [ShowSecondExport]="true" [ShowBuyer]="true"
        [ShowVendor]="true" [QueryFromParent]="onQueryClick()" (listenForm)="getFormValue($event)"
        [ShowUpload]="false"></app-wmsm-conditions>
    </div>
    <div class="信息区" style="float: right"></div>
    <div class="查询区">
      <nz-card>
        <div>
          <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
        </div>

        <div class="表格" style="margin-top: 10px;">
          <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
            [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
            [nzScroll]="{ y: '600px',x:ChangeX }">
            <thead>
              <tr>
                <th scope="col" nzWidth="120px" style="color:rgb(12, 16, 223);font-weight: bold;">{{ "VendorConfirDate"
                  | translate}}</th>
                <th scope="col" nzWidth="120px" style="color:rgb(12, 16, 223);font-weight: bold;">{{ "UserRequiDate" |
                  translate}}</th>
                <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="220px">{{ "Reason" |
                  translate}}</th>
                <th scope="col" nzWidth="200px" style="color:rgb(12, 16, 223);font-weight: bold;">{{ "Remark" |
                  translate}}</th>
                <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="90px">{{ "ShipmentDate" |
                  translate}}</th>
                <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="90px">{{ "ShipmentFile" |
                  translate}}</th>
                <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="90px">{{ "DeliveryDate" |
                  translate}}</th>
                <th scope="col" style="color:rgb(12, 16, 223);font-weight: bold;" nzWidth="120px">{{ "ActualDateArrival"
                  | translate}}</th>
                <th scope="col" nzWidth="150px" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)">{{
                  "table.PONO" | translate}}</th>
                <th scope="col" nzWidth="110px">{{ "table.POLN" | translate}}</th>
                <th scope="col" nzWidth="150px">{{ "table.RTNo" | translate}}</th>
                <th scope="col" nzWidth="110px">{{ "table.RTLine" | translate}}</th>
                <th scope="col" nzWidth="150px">{{ "table.RTDate" | translate}}</th>
                <th scope="col" nzWidth="200px">{{ "table.Buyer" | translate}}</th>
                <th scope="col" nzWidth="150px" *ngIf="!isVendor">{{ "table.PRNO" | translate}}</th>
                <th scope="col" nzWidth="150px" *ngIf="!isVendor">{{ "table.PRDate" | translate}}</th>
                <th scope="col" nzWidth="150px" *ngIf="!isVendor">{{ "table.PRLN" | translate}}</th>
                <th scope="col" nzWidth="150px" *ngIf="isBuyer">{{ "table.AppID" | translate}}</th>
                <th scope="col" nzWidth="150px" *ngIf="isBuyer">{{ "table.AppDept" | translate}}</th>
                <th scope="col" nzWidth="150px" *ngIf="isBuyer">{{ "table.ChargeDept" | translate}}</th>
                <th scope="col" nzWidth="150px" *ngIf="isBuyer">{{ "table.ChargePlantCode" | translate}}</th>
                <th scope="col" nzWidth="150px" *ngIf="isBuyer">{{ "table.PODate" | translate}}</th>
                <th scope="col" nzWidth="150px">{{ "table.DeliverDate" | translate}}</th>
                <th scope="col" nzWidth="150px">{{ "Incoterm" | translate}}</th>
                <th scope="col" nzWidth="150px">{{ "table.POApprovedate" | translate}}</th>
                <th scope="col" nzWidth="110px" *ngIf="isBuyer">{{ "table.VendorCode" | translate}}</th>
                <th scope="col" nzWidth="110px" *ngIf="isBuyer">{{ "table.VendorName" | translate}}</th>
                <th scope="col" nzWidth="110px" *ngIf="isBuyer">{{ "table.Vendor2Code" | translate}}</th>
                <th scope="col" nzWidth="110px" *ngIf="isBuyer">{{ "table.Vendor2Name" | translate}}</th>
                <th scope="col" nzWidth="500px" style="text-align: center">{{ "table.Spec" | translate}}</th>
                <th scope="col" nzWidth="500px" style="text-align: center">{{ "SpecDescription" | translate}}</th>
                <th scope="col" nzWidth="110px">{{ "table.OrderQty" | translate}}</th>
                <th scope="col" nzWidth="150px">{{ "table.BackLogQty" | translate}}</th>
                <th scope="col" nzWidth="50px" *ngIf="!isUser">{{ "table.Unit" | translate}}</th>
                <th scope="col" nzWidth="50px" *ngIf="!isUser">{{ "table.TaxRate" | translate}}</th>
                <th scope="col" nzWidth="100px" *ngIf="isBuyer">{{ "table.POCurrency" | translate}}</th>
                <th scope="col" nzWidth="80px" *ngIf="isBuyer">{{ "table.Company" | translate}}</th>
                <th scope="col" nzWidth="50px" *ngIf="isBuyer" nzWidth="150px">{{ "table.PartNo" | translate}}</th>
                <th scope="col" nzWidth="150px">{{ "table.IMPN" | translate}}</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of colSpanTable.data;let i=index">
                <td>{{data.vDate}}</td>
                <td>{{data.uDate}}</td>
                <td>{{data.unreason}}</td>
                <td>{{data.vendorRemark}}</td>
                <td>{{data.vDeliveryDate | date:'yyyy-MM-dd' }}</td>
                <td style="text-align:center;">
                  <span class="linkLabel" style="text-decoration:underline;color:blue"
                    *ngIf="data.vDispatchFileName == null">
                    <a (click)="downloadFile(data.vDispatchFile,data.vDispatchFileName)">{{data.vDispatchFileName}}</a>
                  </span>
                  <span class="linkLabel" style="text-decoration:underline;color:blue"
                    style="font-size: 20px;cursor: pointer;" nz-icon nzType="file" nzTheme="twotone" nz-tooltip
                    nzTooltipTitle="{{data.vDispatchFileName}}" *ngIf="data.vDispatchFileName != null"
                    (click)="downloadFile(data.vDispatchFile,data.vDispatchFileName)">
                  </span>

                </td>
                <td style="text-align:center;">
                  <span class="linkLabel" style="text-decoration:underline;color:blue"
                    *ngIf="data.vDeliverGoodsFileName == null">
                    <a
                      (click)="downloadFile(data.vDeliverGoodsFile,data.vDeliverGoodsFileName)">{{data.vDeliverGoodsFileName}}</a>
                  </span>

                  <span class="linkLabel" style="text-decoration:underline;color:blue"
                    style="font-size: 20px;cursor: pointer;" nz-icon nzType="file" nzTheme="twotone" nz-tooltip
                    nzTooltipTitle="{{data.vDeliverGoodsFileName}}" *ngIf="data.vDeliverGoodsFileName != null"
                    (click)="downloadFile(data.vDeliverGoodsFile,data.vDeliverGoodsFileName)">
                  </span>

                </td>
                <td>{{data.vAcDate | date:'yyyy-MM-dd'}}</td>
                <td>{{data.pono}}</td>
                <td>{{data.poln}}</td>
                <td>{{data.rtNo}}</td>
                <td>{{data.rtLine}}</td>
                <td>{{data.rtDate}}</td>
                <td>{{data.buyerName}}</td>
                <td *ngIf="!isVendor">{{data.prno}}</td>
                <td *ngIf="!isVendor">{{data.prDate}}</td>
                <td *ngIf="!isVendor">{{data.prln}}</td>
                <td *ngIf="isBuyer">{{data.applicationID}}</td>
                <td *ngIf="isBuyer">{{data.applicationDept}}</td>
                <td *ngIf="isBuyer">{{data.chargeDept}}</td>
                <td *ngIf="isBuyer">{{data.chargePlantCode}}</td>
                <td *ngIf="isBuyer">{{data.poDate}}</td>
                <td>{{data.deliveryDate}}</td>
                <td>{{data.inCoterm}}</td>
                <td>{{data.approvedate}}</td>
                <td *ngIf="isBuyer">{{data.vendorCode}}</td>
                <td *ngIf="isBuyer">{{data.vendorName}}</td>
                <td *ngIf="isBuyer">{{data.vendor2Code}}</td>
                <td *ngIf="isBuyer">{{data.vendor2Name}}</td>
                <td>{{data.spec}}</td>
                <td>{{data.specdec}}</td>
                <td>{{data.orderQty}}</td>
                <td>{{data.baklogQty}}</td>
                <td *ngIf="!isUser">{{data.unit}}</td>
                <td *ngIf="!isUser">{{data.taxRate}}</td>
                <td *ngIf="isBuyer">{{data.poCurrency}}</td>
                <td *ngIf="isBuyer">{{data.companyCode}}</td>
                <td *ngIf="isBuyer">{{data.partNO}}</td>
                <td>{{data.impn}}</td>
              </tr>
            </tbody>
          </nz-table>
          <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
            nzShowSizeChanger [nzPageSize]='pageSize' (nzPageSizeChange)="nzPageSizeChange($event)"
            [nzPageSizeOptions]="[10, 20, 50,100]" (nzPageIndexChange)="nzPageIndexChange($event)"
            [nzItemRender]="renderItemTemplate"></nz-pagination>

          <ng-template #renderItemTemplate let-type let-page="page">

            <a *ngIf="type === 'page'">{{ page }}</a>
            <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
            <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
          </ng-template>

        </div>
      </nz-card>
    </div>
    <!-- <div class="按钮区">
        <div nz-row nzGutter="64">
          <div nz-col>
            <button nz-button nzType="primary" (click)="exportTableToExecl()" class="default-button">{{'DownloadExcel'|translate}}</button>
          </div>
        </div>
      </div> -->
  </div>
</nz-spin>